
import "./App.css";
import Header from "./components/header/header";
import HomePage from "./components/HomePage/HomePage";
import Proporty from "./components/property/proporty";
import List from "./components/list/list";
import Award from "./components/AwardSection/award";
import Locations from "./components/locations/locations";
import Agent from "./components/agents/agent";
import Packages from "./components/packages/package";
import Contact from "./components/contact/contact";
import Footer from "./components/footer/footer";
function App() {

  return (
    <div className="App">
      <Header />
      <HomePage />
      <Proporty />
      <List />
      <Award />
      <Locations />
      <Agent/>
      <Packages/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
